import { useState } from "react";

const dealers = ["Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi"];
const reasons = ["Fiyat Yüksek", "Stok Yok", "Tedarik Süresi", "Kalite", "Diğer"];

const allData = [
  { date: "2026-07-17", product: "Gaming Laptop", brand: "MSI", qty: 2, lostAmount: 42000, dealer: "Teknoloji Dünyası", reason: "Fiyat Yüksek", competitorPrice: 38000 },
  { date: "2026-07-16", product: "4K Webcam", brand: "Logitech", qty: 5, lostAmount: 7500, dealer: "Bilgisayar Plaza", reason: "Stok Yok", competitorPrice: 0 },
  { date: "2026-07-15", product: "34\" UltraWide", brand: "Samsung", qty: 1, lostAmount: 8500, dealer: "Ana Bayi", reason: "Tedarik Süresi", competitorPrice: 8200 },
  { date: "2026-07-14", product: "Tablet 10\"", brand: "Apple", qty: 3, lostAmount: 27000, dealer: "Ofis Market", reason: "Fiyat Yüksek", competitorPrice: 24500 },
  { date: "2026-07-13", product: "Kablosuz Kulaklık", brand: "Sony", qty: 8, lostAmount: 9600, dealer: "Teknoloji Dünyası", reason: "Kalite", competitorPrice: 0 },
  { date: "2026-07-12", product: "Smart Watch", brand: "Samsung", qty: 4, lostAmount: 12000, dealer: "Bilgisayar Plaza", reason: "Stok Yok", competitorPrice: 0 },
];

export default function SalesLossReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealer, setDealer] = useState("");
  const [reason, setReason] = useState("");
  const [search, setSearch] = useState("");

  const data = allData.filter((i) => {
    if (startDate && i.date < startDate) return false;
    if (endDate && i.date > endDate) return false;
    if (dealer && i.dealer !== dealer) return false;
    if (reason && i.reason !== reason) return false;
    if (search && !i.product.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const totalLoss = data.reduce((sum, d) => sum + d.lostAmount, 0);

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-accent-500 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Satış Kaybı Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setDealer(""); setReason(""); setSearch(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {dealers.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Kayıp Nedeni</label>
            <select value={reason} onChange={(e) => setReason(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {reasons.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2 lg:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Satış Kayıpları</h2>
        <div className="flex items-center gap-3">
          <span className="text-sm text-foreground-500">{data.length} kayıt</span>
          <span className="text-sm font-semibold text-accent-600">Toplam Kayıp: ${totalLoss.toLocaleString("en-US")}</span>
        </div>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Tarih</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Kayıp Tutar</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Neden</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Bayi</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 text-foreground-500">{item.date}</td>
                <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.qty}</td>
                <td className="px-4 py-3 text-right font-semibold text-accent-600">${item.lostAmount.toLocaleString("en-US")}</td>
                <td className="px-4 py-3">
                  <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700">{item.reason}</span>
                </td>
                <td className="px-4 py-3 text-foreground-500">{item.dealer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.product}</p>
                <p className="text-xs text-foreground-400">{item.brand} · {item.date}</p>
              </div>
              <p className="text-sm font-bold text-accent-600">${item.lostAmount.toLocaleString("en-US")}</p>
            </div>
            <div className="flex items-center justify-between mt-2">
              <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700">{item.reason}</span>
              <p className="text-xs text-foreground-500">{item.dealer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}